import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ResultsService } from 'src/app/shared/services/master/results/results.service';
//import { Router } from '@angular/router';

@Component({
  selector: 'app-mobinforslts',
  templateUrl: './mobinforslts.component.html',
  styleUrls: ['./mobinforslts.component.scss']
})
export class MobinforsltsComponent implements OnInit {
  rsltType: string = "mobileinfo";
  boolMainHeader: boolean = true;

  title: string;
  staticScreen = false;
  RsltTypeSwitch = false;
  @Output() childTitleEvent = new EventEmitter();

  selectedSubResults: any;

  //constructor(private resultsService: ResultsService, router: Router) {
  //  this.resultsService.NetTestOrMobInfo.subscribe(res => {
  //    if (res.RsltTypeSwitch === true)
  //      router.navigateByUrl('/dashboard/nettest');
  //  });
  //}
  constructor(private resultsService: ResultsService) { }

  ngOnInit() {
  }
  receiveSubRslts($event) {
    this.selectedSubResults = $event;
    //console.log(this.selectedSubResults);//Table Name fo columns headers
  }

  parentEvent(title) {
    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  resetToNetTest() {
    let newRes: any;
    this.resultsService.NetTestOrMobInfo.subscribe(res => newRes = res);
    if (newRes !== undefined) {
      this.resultsService.setNetTestOrMobInfo({
        RsltTypeSwitch: true,
        selectedNetTestIndex: newRes.selectedNetTestIndex,
        selectedMobInfoIndex: newRes.selectedMobInfoIndex
      });
    }
  }
}
